export default {
  title: "Pos Test"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5011: { text: "Ocurrió un error en el catálogo de Pos Test" }
    , WS5011: { text: "Ocurrió un error en el catálogo de Pos Test" }
    , JS5011: { text: "Ocurrió un error en el catálogo de Pos Test" }
    , CR5011: { text: "Ocurrió un error en el catálogo de Pos Test" }
    , UK_PosTest: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/posTest.js